import { NgModule } from '@angular/core';

import { SharedLibsModule } from './shared-libs.module';
import { FindLanguageFromKeyPipe } from '../pipes/find-language-from-key.pipe';
import { TranslateDirective } from '../../directives/translate.directive';
import { AlertComponent } from './components/alert/alert.component';
import { AlertErrorComponent } from './components/alert-error/alert-error.component';
import { HasAnyAuthorityDirective } from '../../directives/has-any-authority.directive';
import { DurationPipe } from '../pipes/duration.pipe';
import { FormatMediumDatetimePipe } from '../pipes/format-medium-datetime.pipe';
import { FormatMediumDatePipe } from '../pipes/format-medium-date.pipe';
import { SortByDirective } from '../../directives/sort-by.directive';
import { SortDirective } from '../../directives/sort.directive';
import { GooglePlacesDirective } from '../../directives/google-places.directive';
import {
  BaryButtonComponent,
  BaryCardComponent,
  BaryCollapseComponent,
  BaryConsoleComponent,
  BaryFileUploadComponent,
  BaryFileUploadVisualComponent,
  BaryIconButtonComponent,
  BaryInputCheckboxComponent,
  BaryInputCountryComponent,
  BaryInputEmailComponent,
  BaryInputGplaceComponent,
  BaryInputMultiCheckboxComponent,
  BaryInputNumberComponent,
  BaryInputPasswordComponent,
  BaryInputPhoneComponent,
  BaryInputPriceComponent,
  BaryInputRadioButtonComponent,
  BaryInputSelectComponent,
  BaryInputSwitchComponent,
  BaryInputTextareaComponent,
  BaryInputTextComponent,
  BaryInputTitleComponent,
  BaryLinkComponent,
  BaryModalAddOrUpdateAddressComponent,
  BaryModalAddOrUpdateHeadbandComponent,
  BaryModalBrowsePdfComponent,
  BaryModalConfirmCanDeactivateComponent,
  BaryModalConfirmComponent,
  BaryModalFiltersComponent,
  BaryModalListErrorComponent,
  BaryModalResultComponent,
  BaryMultiSliderComponent,
  BaryOptionsSelectorComponent,
  BaryOutletTabsComponent,
  BaryPageHeaderComponent,
  BarySiretComponent,
  BarySpecificButtonComponent,
  BaryTransportItemLineComponent,
  CountryNamePipe,
  EstimationPriceComponent,
  WepalInputGplaceComponent,
} from './components';
import { SectionWithCartComponent } from './components/section-with-cart/section-with-cart.component';
import { BaryTitleComponent } from './components/bary-title/bary-title.component';
import { AccessConstraintComponent } from './components/features/access-constraint/access-constraint.component';
import { CartGroupValueComponent } from './components/cart/cart-group-value/cart-group-value.component';
import { TransportLineComponent } from './components/features/transport-line/transport-line.component';
import { BaryDatePickerComponent } from './components/bary-date-picker/bary-date-picker.component';
import { SmoothHeightAnimDirective } from '../../directives/smooth-height-anim.directive';
import { CartSeparatorComponent } from './components/cart/cart-separator/cart-separator.component';
import { MarkAsteriskDirective } from '../../directives/mark-asterisk.directive';
import { CartValueComponent } from './components/cart/cart-value/cart-value.component';
import { TransportLinesComponent } from './components/features/transport-lines/transport-lines.component';
import { LogoUploaderComponent } from 'app/shared/ui/logo-uploader/logo-uploader.component';
import { CustomSlice } from '../pipes/custom-slice.pipe';

import {
  AcceptancesListComponent,
  AddressCardComponent,
  AssociationCardComponent,
  BaryAddressFormComponent,
  BaryTableManagerComponent,
  ChartsStatsComponent,
  CompanyCardComponent,
  CountersStatsLineComponent,
  InsuranceItemsListComponent,
  InsuranceRowComponent,
  OutsideEuDeliveryComponent,
  PopinContactTransportComponent,
  PricingScoreSearchComponent,
  QuotationsListComponent,
  SpecialPlaceCreateDialogComponent,
  StepTrackerComponent,
  TrackAndTraceComponent,
  TransportActionsComponent,
  TransportCardComponent,
  TransporterGroupsListComponent,
  TransportsListComponent,
  TransportViewComponent,
  UploadPricingListComponent,
  UserForcedActivationCardComponent,
} from './ui';
import { DatePickerFormComponent } from './ui/forms/date-picker-form/date-picker-form.component';
import { TransportParametersCardComponent } from './ui/cards/transport-parameters-card/transport-parameters-card.component';
import {
  DataFilterComponent,
  DateFilterComponent,
  FilterButtonComponent,
  NumberFilterComponent,
  PaiementMethodFilterComponent,
  StringFilterComponent,
  TransporterMemberFilterComponent,
} from './ui/data-filter';
import { BaryProceedPaymentModalComponent } from './components/features/modals/bary-modal-proceed-payment/bary-modal-proceed-payment';
import { LoadingConstraintComponent } from './components/features/loading-constraint/loading-constraint.component';
import { TranslatePipe } from '@ngx-translate/core';
import { BaryInputColorComponent } from './components/bary-input-color/bary-input-color.component';
import { CapitalizePipe } from '../pipes/capitalize.pipe';
import { MyRegisteredAddressesListComponent } from './ui/tables/tables-list/my-registered-addresses-list/my-registered-addresses-list.component';
import { MerchandisesListComponent } from './ui/tables/tables-list/merchandises-list/merchandises-list.component';
import { TrackAndTraceItemComponent } from './ui/track-and-trace/track-and-trace-item/track-and-trace-item.component';
import { BarySortableListComponent } from './components/bary-sortable-list/bary-sortable-list.component';
import { ModalChangeOrderComponent } from './components/features/modals/modal-change-order/modal-change-order.component';
import { BaryTableManagerActionButtonComponent } from './ui/tables/bary-table-manager/bary-table-manager-action-button/bary-table-manager-action-button.component';
import { CutoffListComponent } from './ui/tables/tables-list/cutoff-list/cutoff-list.component';
import { DisplayMessageModeratorListComponent } from './ui/tables/tables-list/display-message-moderator-list/display-message-moderator-list.component';
import { TransportEdiHistoryComponent } from './ui/transport-edi-history/transport-edi-history.component';
import { DeliveryStatusFilterComponent } from './ui/data-filter/forms/delivery-status-filter/delivery-status-filter.component';
import { DatetimeFilterComponent } from './ui/data-filter/forms/datetime-filter/datetime-filter.component';
import { UsersListComponent } from './ui/tables/tables-list/users-list/users-list.component';
import { CustomerCardComponent } from './ui/cards/customer-card/customer-card.component';
import { CommentCardComponent } from './ui/cards/comment-card/comment-card.component';
import { TeamContactCardVisualComponent } from './ui/cards/comment-card/team-contact-card-visual/team-contact-card-visual.component';
import { BaryInputMultiSelectComponent } from './components/bary-input-multi-select/bary-input-multi-select.component';
import { BaryModalEditWithConfirmComponent } from './components/features/modals/bary-modal-edit-with-confirm/bary-modal-edit-with-confirm.component';
import { BaryInputAutocompleteComponent } from './components/bary-input-autocomplete/bary-input-autocomplete.component';
import { MinPaletteColisDirective } from '../../directives/min-palette-colis.directive';
import { BaryModalAddTransportIncidentComponent } from './components/features/modals/bary-modal-add-transport-incident/bary-modal-add-transport-incident.component';
import { BaryModalConfirmDeliveryComponent } from './components/features/modals/bary-modal-confirm-delivery/bary-modal-confirm-delivery.component';
import { BaryPricingPackComponent } from '../+estimation';
import { BaryMailtoComponent } from './components/bary-mailto/bary-mailto.component';
import { BaryHistoryUploadComponent } from './components/bary-history-upload/bary-history-upload.component';
import { ModeratorsListComponent } from './ui/tables/tables-list/moderators-list/moderators-list.component';
import { BaryCtaComponent } from './components/bary-cta/bary-cta.component';
import { BaryModalRefundComponent } from './components/features/modals/bary-modal-refund/bary-modal-refund.component';
import { AsFormControlPipe } from '../pipes/as-form-control.pipe';
import { RefundedStatusFilterComponent } from './ui/data-filter/forms/refunded-status-filter/refunded-status-filter.component';
import { PaymentStatusFilterComponent } from './ui/data-filter/forms/payment-status-filter/payment-status-filter.component';
import { BaryModalTransportRefundComponent } from './components/features/modals/bary-modal-transport-refund/bary-modal-transport-refund.component';
import { ImpersonateListComponent } from './ui/tables/tables-list/impersonate-list/impersonate-list.component';
import { RefundsListComponent } from './ui/tables/tables-list/refunds-list/refunds-list.component';
import { SpecialPlaceListComponent } from './ui/tables/tables-list/special-place-list/special-place-list.component';
import { BaryNotificationComponent } from './components/bary-notification/bary-notification.component';
import { NotificationTimelinePipe } from '../pipes/notification-timeline.pipe';

import { BaryWikiLinkComponent } from './components/bary-wiki-link/bary-wiki-link.component';
import { TransportsPendingListComponent } from './ui/tables/tables-list/transports-pending-list/transports-pending-list.component';
import { fullAdressPipe } from '../pipes/full-adress.pipe';
import { DepartmentPipe } from '../pipes/department.pipe';
import { SalesSupportActionsAttributeFilterComponent } from './ui/data-filter/forms/sales-support-actions-attribute-filter/sales-support-actions-attribute-filter.component';
import { PopinEvtTransportComponent } from './ui/tables/tables-list/transports-pending-list/modals/popin-evt-transport/popin-evt-transport.component';
import { PopinDetailTransportComponent } from './ui/tables/tables-list/transports-pending-list/modals/popin-detail-transport/popin-detail-transport.component';
import { OptionFilterPipe } from '../pipes/option-filter.pipe';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { BillsListComponent } from '../+middle/bills/bills-list/bills-list.component';
import { TransformBooleanToYesOrNoPipe } from '../pipes/transform-boolean-to-yes-or-no.pipe';
import { TransportCardBillComponent } from './ui/transport-card/transport-card-bill/transport-card-bill.component';
import { BaryModalErrorRefundPayzenComponent } from './components/features/modals/bary-modal-error-refund-payzen/bary-modal-error-refund-payzen.component';
import { BaryCardsSelectorComponent } from './components/bary-cards-selector/bary-cards-selector.component';
import { TransformBooleanToEnabledOrDisabledPipe } from '../pipes/transform-boolean-to-enabled-or-disabled.pipe';

import { BaryOfferFormComponent } from './ui/forms/bary-offer-form/bary-offer-form.component';
import { TransportExtraConditionFormComponent } from '../+estimation/components/transport-extra-condition-form/transport-extra-condition-form.component';
import { TransportEstimationStepComponent } from '../+estimation/components/modal-estimate/settings-step/transport-estimation-step.component';
import { ItemCountComponent } from './components/pagination/item-count.component';
import { TransportConstraintsPipe } from '../pipes/transport-constraints.pipe';
import { BaryBadgeComponent } from './components/bary-badge/bary-badge.component';
import { BaryIconComponent } from './components/bary-icon/bary-icon.component';
import { MeasureUnitPipe } from '../pipes/measure-unit.pipe';

const standaloneComponents = [
  BaryButtonComponent,
  BaryInputTextComponent,
  BaryInputNumberComponent,
  BaryInputSelectComponent,
  BaryInputCheckboxComponent,
  BaryCardComponent,
  BaryTitleComponent,
  BaryInputSwitchComponent,
  BaryModalErrorRefundPayzenComponent,
  BaryCollapseComponent,
  AlertComponent,
  AlertErrorComponent,
  BaryCtaComponent,
  BaryCardsSelectorComponent,
  BaryInputPriceComponent,
  BaryOptionsSelectorComponent,
  TransportCardBillComponent,
  BaryOfferFormComponent,
  TransportEstimationStepComponent,
  TransportExtraConditionFormComponent,
  TransportCardComponent,
  BaryInputEmailComponent,
  BaryInputPhoneComponent,
  BaryDatePickerComponent,
  BaryInputPasswordComponent,
  AddressCardComponent,
  BaryAddressFormComponent,
  BaryLinkComponent,
  BaryInputTextareaComponent,
  BaryInputCountryComponent,
  BaryInputGplaceComponent,
  BarySiretComponent,
  AssociationCardComponent,
  CompanyCardComponent,
  BaryInputTitleComponent,
  BaryFileUploadComponent,
  BaryMultiSliderComponent,
  BaryHistoryUploadComponent,
  BaryWikiLinkComponent,
  BaryPricingPackComponent,
  BaryInputMultiSelectComponent,
  BaryFileUploadVisualComponent,
  BaryIconComponent,
  BaryBadgeComponent,
  BaryTransportItemLineComponent,
  BarySpecificButtonComponent,
  BaryIconButtonComponent,
  AcceptancesListComponent,
];

const standaloneDirectives = [MarkAsteriskDirective, TranslateDirective, GooglePlacesDirective, HasAnyAuthorityDirective, SortByDirective, SortDirective];

const standalonePipes = [TransformBooleanToYesOrNoPipe, OptionFilterPipe, TransportConstraintsPipe, TransformBooleanToEnabledOrDisabledPipe, MeasureUnitPipe];

@NgModule({
  imports: [SharedLibsModule, PdfViewerModule, ...standaloneDirectives, ...standaloneComponents, ...standalonePipes],
  declarations: [
    BaryModalAddOrUpdateAddressComponent,
    BillsListComponent,
    FindLanguageFromKeyPipe,
    FilterButtonComponent,
    StringFilterComponent,
    DateFilterComponent,
    NumberFilterComponent,
    StepTrackerComponent,
    InsuranceRowComponent,
    OutsideEuDeliveryComponent,
    DataFilterComponent,
    TransportsListComponent,
    TransportViewComponent,
    CountersStatsLineComponent,
    ChartsStatsComponent,
    TransporterMemberFilterComponent,
    PaiementMethodFilterComponent,
    DurationPipe,
    FormatMediumDatetimePipe,
    FormatMediumDatePipe,
    ItemCountComponent,
    BaryNotificationComponent,
    BaryInputRadioButtonComponent,
    BaryConsoleComponent,
    BaryModalResultComponent,
    BaryModalListErrorComponent,
    BaryModalConfirmComponent,
    BaryModalConfirmCanDeactivateComponent,
    SpecialPlaceCreateDialogComponent,
    CountryNamePipe,
    BaryPageHeaderComponent,
    PricingScoreSearchComponent,
    DataFilterComponent,
    BaryModalAddOrUpdateHeadbandComponent,
    BaryOutletTabsComponent,
    BaryTableManagerComponent,
    RefundsListComponent,
    TransporterGroupsListComponent,
    UploadPricingListComponent,
    BaryModalFiltersComponent,
    QuotationsListComponent,
    TrackAndTraceComponent,
    TransportActionsComponent,
    TransportParametersCardComponent,
    DatePickerFormComponent,
    BaryMailtoComponent,
    TransportLineComponent,
    TransportLinesComponent,
    AccessConstraintComponent,
    SmoothHeightAnimDirective,
    CartGroupValueComponent,
    CartValueComponent,
    CartSeparatorComponent,
    SectionWithCartComponent,
    BaryProceedPaymentModalComponent,
    LoadingConstraintComponent,
    BaryInputColorComponent,
    CapitalizePipe,
    MyRegisteredAddressesListComponent,
    LogoUploaderComponent,
    TrackAndTraceItemComponent,
    BarySortableListComponent,
    InsuranceItemsListComponent,
    ModalChangeOrderComponent,
    BaryTableManagerActionButtonComponent,
    CutoffListComponent,
    DisplayMessageModeratorListComponent,
    TransportEdiHistoryComponent,
    DeliveryStatusFilterComponent,
    RefundedStatusFilterComponent,
    PaymentStatusFilterComponent,
    DatetimeFilterComponent,
    UsersListComponent,
    ModeratorsListComponent,
    ImpersonateListComponent,
    CustomerCardComponent,
    CommentCardComponent,
    TeamContactCardVisualComponent,
    CustomSlice,
    MerchandisesListComponent,
    BaryInputMultiCheckboxComponent,
    BaryModalEditWithConfirmComponent,
    MinPaletteColisDirective,
    UserForcedActivationCardComponent,
    BaryInputAutocompleteComponent,
    BaryModalAddTransportIncidentComponent,
    BaryModalConfirmDeliveryComponent,
    WepalInputGplaceComponent,
    EstimationPriceComponent,
    BaryModalRefundComponent,
    BaryModalTransportRefundComponent,
    AsFormControlPipe,
    SpecialPlaceListComponent,
    NotificationTimelinePipe,
    TransportsPendingListComponent,
    PopinContactTransportComponent,
    PopinDetailTransportComponent,
    PopinEvtTransportComponent,
    fullAdressPipe,
    DepartmentPipe,
    SalesSupportActionsAttributeFilterComponent,
    BaryModalBrowsePdfComponent,
    BaryModalAddOrUpdateAddressComponent,
  ],
  exports: [
    ...standalonePipes,
    ...standaloneDirectives,
    ...standaloneComponents,
    BillsListComponent,
    SharedLibsModule,
    FindLanguageFromKeyPipe,
    TranslatePipe,
    FilterButtonComponent,
    StringFilterComponent,
    DateFilterComponent,
    NumberFilterComponent,
    StepTrackerComponent,
    InsuranceRowComponent,
    OutsideEuDeliveryComponent,
    DataFilterComponent,
    TransportsListComponent,
    TransportViewComponent,
    CountersStatsLineComponent,
    ChartsStatsComponent,
    TransporterMemberFilterComponent,
    PaiementMethodFilterComponent,
    DurationPipe,
    FormatMediumDatetimePipe,
    FormatMediumDatePipe,
    ItemCountComponent,
    BaryNotificationComponent,
    BaryInputRadioButtonComponent,
    BaryConsoleComponent,
    BaryModalResultComponent,
    BaryModalListErrorComponent,
    BaryModalConfirmComponent,
    BaryModalConfirmCanDeactivateComponent,
    SpecialPlaceCreateDialogComponent,
    CountryNamePipe,
    BaryPageHeaderComponent,
    PricingScoreSearchComponent,
    DataFilterComponent,
    BaryModalAddOrUpdateHeadbandComponent,
    BaryOutletTabsComponent,
    BaryTableManagerComponent,
    RefundsListComponent,
    TransporterGroupsListComponent,
    UploadPricingListComponent,
    BaryModalFiltersComponent,
    QuotationsListComponent,
    TrackAndTraceComponent,
    TransportActionsComponent,
    TransportParametersCardComponent,
    DatePickerFormComponent,
    TransportLineComponent,
    TransportLinesComponent,
    AccessConstraintComponent,
    SmoothHeightAnimDirective,
    CartGroupValueComponent,
    CartValueComponent,
    CartSeparatorComponent,
    SectionWithCartComponent,
    BaryProceedPaymentModalComponent,
    LoadingConstraintComponent,
    BaryInputColorComponent,
    CapitalizePipe,
    MyRegisteredAddressesListComponent,
    LogoUploaderComponent,
    TrackAndTraceItemComponent,
    BarySortableListComponent,
    InsuranceItemsListComponent,
    ModalChangeOrderComponent,
    BaryTableManagerActionButtonComponent,
    TransportEdiHistoryComponent,
    DeliveryStatusFilterComponent,
    UsersListComponent,
    ModeratorsListComponent,
    ImpersonateListComponent,
    CustomerCardComponent,
    CommentCardComponent,
    TeamContactCardVisualComponent,
    MerchandisesListComponent,
    CustomerCardComponent,
    BaryInputMultiCheckboxComponent,
    MinPaletteColisDirective,
    UserForcedActivationCardComponent,
    BaryInputAutocompleteComponent,
    WepalInputGplaceComponent,
    EstimationPriceComponent,
    BaryModalRefundComponent,
    BaryModalTransportRefundComponent,
    AsFormControlPipe,
    RefundedStatusFilterComponent,
    PaymentStatusFilterComponent,
    SpecialPlaceListComponent,
    NotificationTimelinePipe,
    TransportsPendingListComponent,
    PopinContactTransportComponent,
    PopinDetailTransportComponent,
    PopinEvtTransportComponent,
    BaryModalBrowsePdfComponent,
    BaryModalAddOrUpdateAddressComponent,
  ],
})
export class SharedModule {}
